import { getInjectedProvider } from "./provider";
import { ACTIVE_CONTRACTS, SCN_DECIMALS } from "../config/app.config";

// Prompts the wallet to import the SCN token (EIP-747 wallet_watchAsset).
// Works with MetaMask, Trust Wallet and most injected DEX wallets.
export async function addScnToWallet() {
  const injected = getInjectedProvider();
  if (!injected) throw new Error("NO_WALLET");

  const added = await injected.request({
    method: "wallet_watchAsset",
    params: {
      type: "ERC20",
      options: {
        address: ACTIVE_CONTRACTS.scnToken,
        symbol: "SCN",
        decimals: SCN_DECIMALS,
        image: `${window.location.origin}/logo.png`,
      },
    },
  });
  return added;
}
